import { ScriptStructureType } from "../enums";

export const ScriptStructureMap: Record<ScriptStructureType, string> = {
  [ScriptStructureType.ProductDetails]: "Product Details",
  [ScriptStructureType.EfficiencyFeatures]: "Efficiency features",
  [ScriptStructureType.UserReview]: "User Review",
  [ScriptStructureType.BuyNow]: "Buy Now",
  [ScriptStructureType.AssignGroups]: "Assign Groups",
  [ScriptStructureType.UseGuides]: "Use Guides",
  [ScriptStructureType.PreferentialActivities]: "Preferential activities",
};
